//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poFinishProdCompListAccs', {
//        templateUrl: 'views/components/views/poFinishProdCompListAccs/poFinishProdCompListAccs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'poFinishProdCompListAccsService', 'poFinishProdCompListAccService', 'poFinishProdListService', 'poFinishCompListService', function ($stateParams, stateService, poFinishProdCompListAccsService, poFinishProdCompListAccService, poFinishProdListService, poFinishCompListService) {

//            // #region VARIABLES & DEFINITIONS
            
//            const vm = this;
//            let p2PoFinishKeyno = $stateParams.p2_pofinish_keyno;

//            vm.model = {
//                bgAccumulationSelection: {
//                    selected: 'A',
//                    buttons: [
//                        { id: 'A', label: 'componentpick_all', color: 'primary', onClick: () => vm.model.bgAccumulationSelection.selected = 'A' },
//                        { id: '1', label: 'componentpick_picked', color: 'primary', onClick: () => vm.model.bgAccumulationSelection.selected = '1' },
//                        { id: '0', label: 'componentpick_not_picked', color: 'primary', onClick: () => vm.model.bgAccumulationSelection.selected = '0' }
//                    ]
//                },
//                setting: {},
//                itemsListComponents: [],
//                lockedFinish: false,
//                lockedAbort: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS
            
//            async function loadSetting() {
//                vm.model.setting = (await poFinishProdCompListAccService.getStatus({ p2_pofinish_keyno: p2PoFinishKeyno }))[0];
//            }

//            async function loadComponents() {
//                vm.model.itemsListComponents = await poFinishProdCompListAccsService.listComponents({
//                    p2_pofinish_keyno: p2PoFinishKeyno,
//                    selector: vm.model.bgAccumulationSelection.selected
//                });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region FINISH PRODUCTION ORDER BUTTON FUNCTION
            
//            vm.finishChanges = function () {
//                vm.model.lockedFinish = true;

//                poFinishCompListService.finishProductionOrder({
//                    finishfromkey: 'p2_pofinish_keyno',
//                    keyvalue: p2PoFinishKeyno,
//                    from_webpagename: stateService.getCurrentName(),
//                    from_parms: p2PoFinishKeyno
//                }).then((response) => {
//                    vm.model.lockedFinish = false;

//                    stateService.go(response[0].webpagename, response[0].webpage_parms);
//                }, () => vm.model.lockedFinish = false);
//            }

//            // #endregion FINISH PRODUCTION ORDER BUTTON FUNCTION

//            // #region ABORT BUTTON FUNCTION
            
//            vm.abortTask = function () {
//                vm.model.lockedAbort = true;

//                poFinishProdListService.abortPoFinish({ p2_pofinish_keyno: p2PoFinishKeyno }).then((response) => {
//                    vm.model.lockedAbort = false;

//                    stateService.back('/' + response[0].webpagename + '/' + response[0].webpage_parms);
//                }, () => vm.model.lockedAbort = false);
//            }
            
//            // #endregion ABORT BUTTON FUNCTION

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgAccumulationSelection = function (value) {
//                vm.model.bgAccumulationSelection.selected = value;
//                loadComponents();
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadSetting();
//                loadComponents();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
